import { useClientId, useCopyPasteStyles, useDeviceType } from "@blocks/hooks";
import { Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { EditProps } from "blocks/types";
import classnames from "classnames";
import React from "react";
import { useBlockStyle } from "../../hooks";

import InspectorControls from "./components/InspectorControls";
import { Icon } from "@blocks/components";

const Edit: React.ComponentType<EditProps<any>> = (props) => {
	const {
		className,
		attributes: {
			typography,
			hideOnDesktop,
			enableAuthorIcon,
			enableDateIcon,
			enableCommentIcon,
			enableAuthor,
			enableComment,
			enableDate,
			dateIcon,
			commentIcon,
		},
		setAttributes,
	} = props;

	const { clientId } = useClientId(props);
	const { deviceType } = useDeviceType();
	const { CopyPasterStyleBlockControl } = useCopyPasteStyles();
	const { Style } = useBlockStyle({
		blockName: "post-meta",
		clientId,
		attributes: props.attributes,
		deviceType,
	});

	const classNames = classnames(
		`mzb-post-meta mzb-post-meta-${clientId}`,
		className,
		typography?._className,
		hideOnDesktop && "magazine-blocks-hide-on-desktop"
	);

	const separatorMap: Record<string, string> = {
		dash: "—",
		dot: "·",
		pipe: "|",
		slash: "/",
		none: "",
	};

	const separator = separatorMap[props.attributes.separatorType || "dash"];

	return (
		<Fragment>
			<InspectorControls
				attributes={props.attributes}
				setAttributes={setAttributes}
			/>
			<CopyPasterStyleBlockControl withBlockControls />
			<Style />
			<div className={classNames}>
				<div className="mzb-post-meta-content">
					{enableAuthor && (
						<>
							<span className="mzb-post-meta-author">
								{enableAuthorIcon && (
									<>
										<svg
											width="16"
											height="16"
											fill="currentColor"
											viewBox="0 0 16 16"
										>
											<path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm4-3a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" />
											<path d="M14 14s-1-1.5-6-1.5S2 14 2 14V13a6 6 0 1 1 12 0v1z" />
										</svg>
									</>
								)}

								<span>{__("John Doe", "magazine-blocks")}</span>
							</span>
						</>
					)}

					{enableDate && (
						<>
							<span className="mzb-post-meta-separator">
								{separator}
							</span>
							<span className="mzb-post-meta-date">
								{enableDateIcon && (
									<>
										{dateIcon ? (
											<Icon
												type="frontendIcon"
												name={dateIcon}
												size={24}
											/>
										) : (
											<svg
												width="16"
												height="16"
												fill="currentColor"
												viewBox="0 0 16 16"
											>
												<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 3v1h14V3a1 1 0 0 0-1-1h-1v.5a.5.5 0 0 1-1 0V2H4v.5a.5.5 0 0 1-1 0V2H2a1 1 0 0 0-1 1zm14 2H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z" />
											</svg>
										)}
									</>
								)}
								<span>
									{__("June 10, 2024", "magazine-blocks")}
								</span>
							</span>
						</>
					)}

					{enableComment && (
						<>
							<span className="mzb-post-meta-separator">
								{separator}
							</span>
							<span className="mzb-post-meta-comment">
								{enableCommentIcon && (
									<>
										{commentIcon ? (
											<Icon
												type="frontendIcon"
												name={commentIcon}
												size={24}
											/>
										) : (
											<svg
												width="16"
												height="16"
												fill="currentColor"
												viewBox="0 0 16 16"
											>
												<path d="M8 3a5 5 0 0 0-4.546 2.914A.5.5 0 0 0 3.5 7h9a.5.5 0 0 0 .046-.086A5 5 0 0 0 8 3zm-7 5a7 7 0 1 1 14 0A7 7 0 0 1 1 8zm7 6a6.978 6.978 0 0 1-4.546-1.914A.5.5 0 0 1 3.5 13h9a.5.5 0 0 1 .046-.086A6.978 6.978 0 0 1 8 14z" />
											</svg>
										)}
									</>
								)}

								<span>
									{__("5 Comments", "magazine-blocks")}
								</span>
							</span>
						</>
					)}
				</div>
			</div>
		</Fragment>
	);
};

// @ts-ignore
export default Edit;
